// extracted by mini-css-extract-plugin
export default {"buyBtn":"NoAccess_buyBtn__plL8x","noAccessContainer":"NoAccess_noAccessContainer__K2OvK","text":"NoAccess_text__-oJpW","title":"NoAccess_title__KR7qX"};